import { t } from '@hefe/i18n';
import { User, UserBasic } from '@hefe/models';

export const fullUserName = (user?: User | UserBasic | undefined | null) => {
  if (user) {
    return `${user.firstname} ${user.lastname}`;
  }
  return '';
};

export const userHasRole = (role: string[], user?: User) => {
  if (user) {
    return user?.role.some((r) => role.includes(r));
  }

  return false;
};

export const clubHasSubscription = (subscription: string[], user?: User) => {
  if (user) {
    return subscription.includes(user?.club_subscription?.active);
  }

  return false;
};

export const userSex = (user?: User) => {
  switch (user?.sex) {
    case 1:
      return t('sex.male');
    case 2:
      return t('sex.female');
    case 3:
      return t('sex.diverse');
    default:
      return '-';
  }
};
